import React from "react";
import ReactDOM from "react-dom";          // ← react-dom, pas react-dom/client
import { I18nProvider } from "./trader/i18n";
import { AppThemeProvider } from "./trader/ThemeContext";
import App from "./trader/App";

// ✅ API React 17
ReactDOM.render(
  <React.StrictMode>
    <I18nProvider>
      <AppThemeProvider>
        <App />
      </AppThemeProvider>
    </I18nProvider>
  </React.StrictMode>,
  document.getElementById("root")
);